import {
  AboutContainer,
  Button,
  Container,
  Content,
  Icon,
  MemberContainer,
  MemberLinkedin,
  MemberName,
  MemberPhoto,
  Subtitle,
  TeamContainer,
  Title,
} from "./style";
import gabriel from "../../Assets/aboutUs/gabriel.png";
import iago from "../../Assets/aboutUs/iago.png";
import maykel from "../../Assets/aboutUs/maykel.png";
import rafael from "../../Assets/aboutUs/rafael.png";
import vinicius from "../../Assets/aboutUs/vinicius.png";
import linkedin from "../../Assets/aboutUs/linkedin.svg";
import { useHistory } from "react-router";
import Footer from "../../Components/Footer";

const AboutUs = () => {
  const history = useHistory();

  const handleClick = (data: string) => {
    history.push(data);
  };
  return (
    <Container>
      <AboutContainer>
        <Title>Soluções modernas para empresas modernas</Title>
        <Subtitle>O que é?</Subtitle>
        <Content>
          Um sistema de gerenciamento de estabelecimentos hoteleiros leve e
          flexível.
        </Content>
        <Subtitle>Anytime, anywhere</Subtitle>
        <Content>
          Baseado na web, pode ser utilizado de qualquer dispositivo, permitindo
          uma visão clara e em tempo real do seu estabelecimento
        </Content>
      </AboutContainer>
      <AboutContainer>
        <Title>Time de desenvolvedores</Title>
        <TeamContainer>
          <MemberContainer>
            <MemberPhoto src={gabriel} />
            <MemberName>Gabriel Freitas</MemberName>
            <MemberLinkedin
              href="https://www.linkedin.com/in/elgabrielfreitas/"
              target="_blank"
            >
              <Icon src={linkedin}></Icon>
            </MemberLinkedin>
          </MemberContainer>
          <MemberContainer>
            <MemberPhoto src={iago} />
            <MemberName>Iago Vinicius</MemberName>
            <MemberLinkedin
              href="https://www.linkedin.com/in/iago-vin%C3%ADcius-souza-de-sales-90209912a/"
              target="_blank"
            >
              <Icon src={linkedin}></Icon>
            </MemberLinkedin>
          </MemberContainer>
          <MemberContainer>
            <MemberPhoto src={maykel} />
            <MemberName>Maykel Nekel</MemberName>
            <MemberLinkedin
              href="https://www.linkedin.com/in/maykelnekel/"
              target="_blank"
            >
              <Icon src={linkedin}></Icon>
            </MemberLinkedin>
          </MemberContainer>
          <MemberContainer>
            <MemberPhoto src={rafael} />
            <MemberName>Rafael Maier</MemberName>
            <MemberLinkedin
              href="https://www.linkedin.com/in/rafael-rodrigues-maier-933446200/"
              target="_blank"
            >
              <Icon src={linkedin}></Icon>
            </MemberLinkedin>
          </MemberContainer>
          <MemberContainer>
            <MemberPhoto src={vinicius} />
            <MemberName>Vinicius Troyack</MemberName>
            <MemberLinkedin
              href="https://www.linkedin.com/in/vinicius-troyack-5b4128194/"
              target="_blank"
            >
              <Icon src={linkedin}></Icon>
            </MemberLinkedin>
          </MemberContainer>
        </TeamContainer>
      </AboutContainer>
      <Button onClick={() => handleClick("/")}>Comece agora mesmo</Button>
      <Footer />
    </Container>
  );
};
export default AboutUs;
